import { BrokerpagepopComponent } from './../../components/brokerpagepop/brokerpagepop';
import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { NavController, PopoverController, ModalController, AlertController, ToastController, LoadingController, App,NavParams, IonicPage } from 'ionic-angular';
import { ViewContactPage } from '../view-contact/view-contact';
import { EditPopoverPage } from '../edit-popover/edit-popover';
import firebase from 'firebase/app';
import { ChangeAssignedBrokerPage } from '../change-assigned-broker/change-assigned-broker';
import { LoadingProvider } from '../../providers/loading/loading';
import { Http, RequestOptions, Headers } from '@angular/http';
import { StepformPage } from '../stepform/stepform';
import { TentativeRealEstateAssetPage } from '../tentative-real-estate-asset/tentative-real-estate-asset';
import { ChangeLogProfilePage } from '../change-log-profile/change-log-profile';
import { HomeService } from '../../app/services/home-service';
import { EnvDataService } from '../../app/services/env-data-service';
import { ContactFormService } from '../edit-contact-form-list/services/contact-form.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { EditContactList } from '../edit-contact-form-list/edit-contact-from-list';
import { ShowContactForm } from '../show-contact/show-contact';
@IonicPage({
  segment: 'contact-list'
})
@Component({
  selector: 'contact-list-page',
  templateUrl: 'contact_list.html',
  providers: [EnvDataService, ContactFormService]
})
export class ContactList implements OnInit {

  addContactForm: FormGroup;
  public usersList: any[];
  public userRole: any;
  public allBrokers: any;
  public loadedUsersList: any[];
  public contactTotal: number;
  public contactTmore: number;
  public limit = 20;
  public offset = 1;
  public addContactShow =false;
  public inputSearch ='';
  public uid:any;
  public broker_uid:any = [];

  public validation_messages = {
    'firstname': [
      { type: 'required', message: 'Firstname is required.' }
    ],
    'lastname': [
      { type: 'required', message: 'Lastname is required.' }
    ],
    'email': [
      { type: 'required', message: 'Email is required.' }
    ],
    'reference_broker': [
      { type: 'required', message: 'Please select broker.' }
    ],
    'mobile_phone': [
      { type: 'required', message: 'Mobile Number is required.' },
      { type: 'minlength', message: 'Mobile Number must be at least 10 digit long.' },
      { type: 'maxlength', message: 'Mobile Number must be at least 10 digit long.' }
    ]
  }

  constructor(
    public navCtrl: NavController,
    private firestore: AngularFirestore,
    public loadingProvider: LoadingProvider,
    public popoverCtrl: PopoverController,
    public loadingCtrl: LoadingController,
    public modalCtrl: ModalController,
    public http: Http,
    public toastCtrl: ToastController,
    public alertCtrl: AlertController,
    public HomeService: HomeService,
    public db: AngularFirestore,
    private EnvDataService: EnvDataService,
    private ContactFormService: ContactFormService,
    public formBuilder: FormBuilder,
    public app: App,
    public navParams: NavParams,
  ) {

    debugger;
    let homepage = this.navParams.get("homepage");
    if(homepage) {
      this.addContactShow=true;
    }

    this.addContactForm = formBuilder.group({
      firstname: ['', Validators.compose([Validators.required])],
      lastname: ['', Validators.compose([Validators.required])],
      mobile_phone: ['', Validators.compose([Validators.required, Validators.minLength(12), Validators.maxLength(12)])],
      email: ['', Validators.compose([Validators.required, Validators.email])],
      reference_broker: [''],
    });

    this.userRole = window.localStorage.getItem("userRole");
    this.uid = window.localStorage.getItem("uid");
    if (this.userRole == 'super_admin') {
      let reference_broker = this.addContactForm.get('reference_broker');
      reference_broker.setValidators(Validators.required);
      reference_broker.updateValueAndValidity();
    }
    this.getAllBrokers().subscribe((data) => {
      console.log(data);
      this.allBrokers = data;
    });

    let thiss = this;

    this.getuserlist();

  }

  getAllBrokers() {
    return this.db.collection<any>("users", ref => ref.where('roles.broker', '==', true)).valueChanges();
  }

  ngOnInit() {
    this.contactTmore = 1;
  }

  getuserlist() {

    if(this.userRole == 'broker') {
      //this.broker_uid = [];
      //this.limit = 10;
      this.broker_uid.push(this.uid);
      this.ContactFormService.getAllApplicantContact(this.limit, this.offset,this.broker_uid).then((data) => {

        console.log(data);
        this.assigndata(data);

      });

    }
    else if(this.userRole == 'loan_admin') {
      this.ContactFormService.getUserdata(this.uid).then((brokerdata:any) => {
         this.broker_uid = brokerdata.assigned_broker;
        this.ContactFormService.getAllApplicantContact(this.limit, this.offset,this.broker_uid).then((data) => {

          //console.log(data);
          this.assigndata(data);

        });


      });
    }
    else {
      this.ContactFormService.getAllApplicantContact(this.limit, this.offset).then((data) => {

        console.log(data);
        this.assigndata(data);

      });
    }

  }

  assigndata(data) {
    this.usersList = data;
    this.loadedUsersList = data;

  }

  presentToast(err) {
    const toast = this.toastCtrl.create({
      message: err,
      duration: 3000,
      position: 'bottom'
    });

    toast.present();
  }

  add_contact() {
    let thiss = this;
    if (!this.addContactForm.valid) {
      this.addContactForm.get('lastname').markAsDirty();
      this.addContactForm.get('lastname').markAsTouched();

      this.addContactForm.get('firstname').markAsDirty();
      this.addContactForm.get('firstname').markAsTouched();

      this.addContactForm.get('mobile_phone').markAsDirty();
      this.addContactForm.get('mobile_phone').markAsTouched();

      this.addContactForm.get('email').markAsDirty();
      this.addContactForm.get('email').markAsTouched();

      this.addContactForm.get('reference_broker').markAsDirty();
      this.addContactForm.get('reference_broker').markAsTouched();

    } else {
      this.loadingProvider.startLoading();
      let uid = window.localStorage.getItem("uid");
      if (uid != null) {
        let firstname = this.addContactForm.value.firstname;
        let lastname = this.addContactForm.value.lastname;
        let email = this.addContactForm.value.email;
        let mobile_phone = this.addContactForm.value.mobile_phone;
        let reference_broker = this.addContactForm.value.reference_broker;
        let password = this.stringGen(10);

        let postData = {
          "super_admin_uid": uid,
          "displayName": firstname,
          "email": email,
          "phoneNumber": "+6" + mobile_phone.split(" ").join(""),
          "password": password,
          "firstname": firstname,
          "lastname": lastname,
          "mobile_phone": mobile_phone,
          "deleted": 0,
          "created_date": new Date().getTime(),
          "roles": {
            contact: true
          },
        }

        if (window.localStorage.getItem("userRole") == "broker") {
          postData['reference_broker'] = uid;
        } else {
          postData['reference_broker'] = reference_broker;
        }

        postData['brokerFirstname'] = window.localStorage.getItem("brokerFirstname");
        postData['brokerLastname'] = window.localStorage.getItem("brokerLastname");
        postData['brokerEmail'] = window.localStorage.getItem("email");

        let applicantobj = {
          user_data: postData
        }


        //this.loadingProvider.stopLoading();
        this.ContactFormService.saveApplicantDetails(applicantobj).then((data: any) => {
          console.log(thiss);
          console.log(data);
          thiss.loadingProvider.stopLoading();
          if(data.deleted==1){
            //thiss.loadingProvider.stopLoading();

            let alert = this.alertCtrl.create({
              title: 'Confirm create Applicant',
              message: 'Email or mobile already exists in the database but deleted mode. If you want to restore click Yes or click No to create a new contact.',
              buttons: [
                {
                  text: 'No',
                  handler: () => {

                    //thiss.loadingProvider.startLoading();

                    thiss.ContactFormService.updateUserStatus(data.uid,1).then((data: any) => {

                      if(data.status=='success'){
                        //thiss.loadingProvider.stopLoading();
                      }
                    });
                  }
                },
                {
                  text: 'Yes',
                  handler: () => {

                    //thiss.loadingProvider.startLoading();

                    thiss.ContactFormService.updateUserStatus(data.uid,0).then((data: any) => {
                      //thiss.loadingProvider.stopLoading();
                      if(data.status=='success'){
                        thiss.presentToast(data.message);
                        setTimeout(() => {
                          thiss.getuserlist();
                        }, 1000);

                      }
                    });
                  }
                }
              ]
            });
            alert.present();

          }else if (data.message == 'User is not found.') {
           // thiss.loadingProvider.stopLoading();
            thiss.presentToast(data.message);
          } else if (data.message == 'Phone number is already exists') {
           // thiss.loadingProvider.stopLoading();
            thiss.presentToast(data.message);
          } else if (data.message == 'Email is already exists') {
            //thiss.loadingProvider.stopLoading();
            thiss.presentToast(data.message);
          } else {
            debugger;
            thiss.addContactForm.reset()
           // thiss.loadingProvider.stopLoading();
            thiss.getuserlist();
            //var nav = this.app.getRootNav();
            window.localStorage.setItem("editUserId", data.uid);

            let contact_uid = data.uid

            // thiss.navCtrl.push(EditContactList,{
            //   'editUserId':contact_uid
            // });
            thiss.navCtrl.push(ShowContactForm,{
              'contact_uid':contact_uid
            });

          }

        });
      }
    }
  }

  stringGen(len) {
    var text = "";
    var charset = "abcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < len; i++)
      text += charset.charAt(Math.floor(Math.random() * charset.length));
    return text;
  }

  onPaste(event) {
    let clipboardData = event.clipboardData;
    let pastedText = clipboardData.getData('text');
    pastedText = pastedText.split(" ").join("");
    let firstFour = pastedText.slice(0, 4);
    let number = pastedText.slice(4, 10);
    number = firstFour + ' ' + number.slice(0, 3) + ' ' + number.slice(3);
    this.addContactForm.controls.mobile_phone.setValue('');
    this.addContactForm.controls.mobile_phone.setValue(number.trim());
  }

  setFormatNumber(event) {
    var mobile_phone = this.addContactForm.controls.mobile_phone.value;
    mobile_phone = mobile_phone.split(" ").join("");
    let firstFour = mobile_phone.slice(0, 4);
    let number = mobile_phone.slice(4, 10);
    number = firstFour + ' ' + number.slice(0, 3) + ' ' + number.slice(3);
    this.addContactForm.controls.mobile_phone.setValue(number.trim());
  }


  phoneInput(event) {

    let pass = /[4][8-9]{1}/.test(event.charCode) || /[5][0-7]{1}/.test(event.charCode);
    if (!pass) {
      return false;
    }
  }



  edit(i) {

    //debugger;
    // var nav = this.app.getRootNav();
     window.localStorage.setItem("editUserId", this.usersList[i].uid);
    // nav.setRoot(EditContactList);

    //window.localStorage.setItem("editUserId", this.contact_uid);
    //nav.setRoot(EditContactList);

    let contact_uid = this.usersList[i].uid;

    this.navCtrl.push(EditContactList,{
      'editUserId':contact_uid
    });


  }

  delete(i) {

    let alert = this.alertCtrl.create({
      title: 'Confirm delete Applicant',
      message: 'Are you sure you want to delete this Applicant?',
      buttons: [
        {
          text: 'No',
          handler: () => {

          }
        },
        {
          text: 'Yes',
          handler: () => {
            this.ContactFormService.deleteApplicantDetails(this.usersList[i].uid).then((data: any) => {
              if (data.message == "Document successfully deleted!") {
                this.getuserlist();
              } else {
                this.presentToast(data.message);
              }
            });
          }
        }
      ]
    });
    alert.present();
  }





  searchUserFocus(){
    debugger;
    var limit = '';
    var offset= '';
    if(this.inputSearch == '') {
      this.ContactFormService.getAllApplicantContact(limit, offset).then((data:any) => {
        console.log(data);

        if(data.length!=0){
          this.assigndata(data);
        }

      });
    }
    else {

      var input, filter, table, tr, td, td1, td2, i, txtValue, txtValue1, txtValue2;
      // input = evt.srcElement.value;
      // this.inputSearch = input;
      input = this.inputSearch;
      filter = input.toLowerCase();
      table = document.getElementById("myTable");
      tr = table.getElementsByTagName("tr");
      for (i = 0; i < tr.length; i++) {
        td = tr[i].getElementsByTagName("td")[0];
        td1 = tr[i].getElementsByTagName("td")[1];
        td2 = tr[i].getElementsByTagName("td")[2];
        if (td) {
          this.contactTmore = 0;
          txtValue = td.textContent || td.innerText;
          txtValue1 = td1.textContent || td1.innerText;
          txtValue2 = td2.textContent || td2.innerText;
          if (txtValue.toLowerCase().indexOf(filter) > -1 || txtValue1.toLowerCase().indexOf(filter) > -1 || txtValue2.toLowerCase().indexOf(filter) > -1) {
            tr[i].style.display = "";
          } else {
            tr[i].style.display = "none";

          }
        }

        if(input==""||input==null){
          this.contactTmore = 1;
          this.inputSearch = '';
          this.getuserlist();
        }

      }

    }

  }

  searchcontact(event) {
    console.log(event);
    //debugger;
   let searchkey =  event.value;
   this.inputSearch = event.value;

    if(searchkey !== '') {
      //console.log(this.allcontactlist);
        //this.filterdata(searchkey)
        //console.log(this.allcontactlist);
        this.ContactFormService.searchAllContacts(searchkey).then((data:any = []) => {
          console.log(data);
          this.assigndata(data);
        });
    }
    else {
      this.getuserlist();
    }

  }
  searchUser(evt) {

    if (!evt.srcElement.value) {
      debugger;
      this.inputSearch = '';
      this.getuserlist();
      return;
    }
    var input, filter, table, tr, td, td1, td2, i, txtValue, txtValue1, txtValue2;
    input = evt.srcElement.value;
    this.inputSearch = input;
    filter = input.toLowerCase();
    table = document.getElementById("myTable");
    tr = table.getElementsByTagName("tr");
    for (i = 0; i < tr.length; i++) {
      td = tr[i].getElementsByTagName("td")[0];
      td1 = tr[i].getElementsByTagName("td")[1];
      td2 = tr[i].getElementsByTagName("td")[2];
      if (td) {
        this.contactTmore = 0;
        txtValue = td.textContent || td.innerText;
        txtValue1 = td1.textContent || td1.innerText;
        txtValue2 = td2.textContent || td2.innerText;
        if (txtValue.toLowerCase().indexOf(filter) > -1 || txtValue1.toLowerCase().indexOf(filter) > -1 || txtValue2.toLowerCase().indexOf(filter) > -1) {
          tr[i].style.display = "";
        } else {
          tr[i].style.display = "none";

        }
      }

      if(evt.srcElement.value==""||evt.srcElement.value==null){
        this.contactTmore = 1;
        this.inputSearch = '';
        this.getuserlist();
      }

    }

  }

  loadData(event, endBefore) {
    console.log(this.inputSearch);
    debugger;
    this.offset=this.offset+1;
    var limit = 20;
    //this.getuserlist()

    if(this.inputSearch == '')
    {
      if(this.userRole == 'broker') {
        //let broker_uid = [];
        //this.limit = 10;
        //this.broker_uid.push(this.uid);
        this.ContactFormService.getAllApplicantContact(this.limit, this.offset,this.broker_uid).then((data) => {
          event.complete();
          //console.log(data);
          this.assigndata(data);

        });

      }
      else if(this.userRole == 'loan_admin') {
        this.ContactFormService.getAllApplicantContact(this.limit, this.offset,this.broker_uid).then((data) => {
          event.complete();
          //console.log(data);
          this.assigndata(data);

        });
      }
      else {
        this.ContactFormService.getAllApplicantContact(this.limit, this.offset).then((data) => {
          event.complete();
          //console.log(data);
          this.assigndata(data);

        });
      }
    }


    // this.ContactFormService.getAllApplicantContact(this.limit, this.offset).then((data) => {

    //   event.complete();
    //   console.log(data);
    //   this.assigndata(data);

    // });
    // setTimeout(() => {
    //   event.complete();

    // }, 3000)

  }

  assigndataload(data) {
    this.usersList = this.usersList.concat(data);

  }


  initializeItems(): void {
    this.usersList = this.loadedUsersList;

  }

  viewContact(event, contact_uid){

    this.navCtrl.push(ShowContactForm,{
      contact_uid:contact_uid,
      });
  }

  addContact(){
    this.addContactShow=true;
  }

  removeContact() {
    this.addContactShow=false;
  }

  changeBroker(event,item) {
    console.log(event);

    let editMenu = this.popoverCtrl.create(BrokerpagepopComponent,
      {
        contact_uid: item.uid,

    }, {showBackdrop: true, cssClass: 'popOverClass'});
    editMenu.present({
       ev: event
    });
    editMenu.onDidDismiss((data) => {
      //alert('working');
      //this.adf_flag = data;
      console.log(data);
       if(data) {
        item.broker_data.firstname = data.name;
        item.broker_data.lastname = '';
       }

      //this.assigned_broker_name = data;
    })
  }


}


// WEBPACK FOOTER //
// ./src/pages/contact-list/contact_list.ts